module.exports = __webpack_public_path__ + "../fonts/slick.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slick-carousel/slick/fonts/slick.ttf
// module id = 280
// module chunks = 0 1